const GEAR3_URL_MAP: Record<string, string> = {
  '192.168.1.16:5078': 'http://192.168.1.16:5077',
  'localhost:8080': 'http://192.168.1.130:9921',
  '192.168.1.17:5077': 'http://192.168.1.17:5087',
  '192.168.1.6:5079': 'http://192.168.1.6:5087',
  'gear.geteducation.net': 'https://gear-ai.geteducation.net',
  'gear-uat.geteducation.net': 'https://gear-uat.geteducation.net',
};

export function getGear3LoginUrl(loginId: string) {
  const targetBaseUrl = GEAR3_URL_MAP[window.location.host];
  if (!targetBaseUrl) {
    return '';
  }

  const targetUrl = new URL(targetBaseUrl);
  if (loginId) {
    targetUrl.searchParams.set('username', encodeURIComponent(window.btoa(unescape(encodeURIComponent(loginId)))));
    targetUrl.searchParams.set('showUpgradeNotice', '1');
  }
  return targetUrl.toString();
}

export function redirectToGear3Login(loginId: string) {
  const targetUrl = getGear3LoginUrl(loginId);
  if (targetUrl) {
    window.location.href = targetUrl;
  }
}
